<template>
  <div class="mx-10 ma-5">
    <v-card flat class="pa-5">
      <div>
        <PageTitleWithSearch
          :title="'Grn'"
          :btnName="'Create New Grn'"
          :btnColor="'#00B3FF'"
          :btnRoute="'/grn/create'"
          :btnPermission="'grn.create'"
          :btnEnable="true"
          :loading="loading"
          :search="search"
          @searchText="searchChange($event)"
        />

        <DataTableWithPagination
          :headers="tableHeaders"
          :items="grnList"
          :loading="loading"
          :page="page"
          :total="total"
          @pageChange="page = $event"
        >
          <template #row="{ item }">
            <tr
              :key="item.grn_number"
              @click="hasPermission('grn.view') && goToGrnDetails(item)"
            >
              <td>{{ item.grn_number }}</td>
              <td class="text-center">{{ item.grn_date }}</td>
              <td class="text-center">{{ item.po_number }}</td>
              <td class="text-center">{{ item.supplier_name }}</td>
              <td class="text-center">{{ item.grand_total }}</td>
              <!-- <td class="text-center">
                <v-btn
                  v-if="hasPermission('grn.edit')"
                  class="ma-1"
                  color="#FFE0B2"
                  :to="'/grn/edit/' + item.uuid"
                  fab
                  x-small
                  style="box-shadow: none;"
                >
                  <v-icon small color="#FF9800">mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  v-if="hasPermission('grn.delete')"
                  class="my-1"
                  x-small
                  color="#FFCDD2"
                  @click.stop="dropMemberConfirm(item.uuid)"
                  fab
                  style="box-shadow: none;"
                >
                  <v-icon dark small color="#F44336">mdi-delete</v-icon>
                </v-btn>
              </td> -->
            </tr>
          </template>
        </DataTableWithPagination>
      </div>
    </v-card>
    <ConfirmModal
      :text="'Do you want to drop this GRN?'"
      :title="'Drop GRN'"
      :color="'red'"
      :confirmOpen="confirmOpen"
      @cancelConfirm="cancelConfirm()"
      @confirm="confirm()"
    ></ConfirmModal>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'warning'"
      @closeSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import { GrnService } from "@/services/grn-service.js";
import ConfirmModal from "@/components/shared/ConfirmModal";
import Snackbars from "@/components/shared/Snackbars";
import DataTableWithPagination from "@/components/shared/DataTableWithPagination.vue";
import { checkError } from "@/config/errors.js";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers("settings");

export default {
  name: "grnList",
  components: {
    PageTitleWithSearch,
    ConfirmModal,
    Snackbars,
    DataTableWithPagination,
  },
  data() {
    return {
      loading: false,
      search: "",
      confirmOpen: false,
      snackbar: false,
      dropId: null,
      grnList: [],
      page: 1,
      total: 0,
      headers: [
        { text: "GRN Number", align: "start", value: "grn_number" },
        { text: "GRN Date", align: "center", value: "grn_date" },
        { text: "PO Number", align: "center", value: "po_number" },
        { text: "Supplier Name", align: "center", value: "supplier_name" },
        {
          text: "Grand Total",
          align: "center",
          value: "grand_total",
          isCurrency: true,
        },
        // { text: "Actions", align: "center", value: "actions" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
    ...mapSettingsGetters({
      currencyCode: "currencyCode",
    }),
    tableHeaders() {
      return this.headers.map((h) => {
        if (h.isCurrency) {
          return {
            ...h,
            text: `${h.text} (${this.currencyCode})`, // Add currency code automatically
          };
        }
        return h;
      });
    },
  },
  created() {
    this.fetchGrnList();
  },
  watch: {
    search(newSearch) {
      this.fetchGrnList(newSearch);
    },
    page() {
      this.fetchGrnList(this.search);
    },
  },
  methods: {
    async fetchGrnList(search = "") {
      this.loading = true;
      try {
        const response = await GrnService.getGrnList(search, this.page);
        this.grnList = response.data?.data || [];
        this.total = response.data?.meta?.last_page || 0;
      } catch (error) {
        this.grnList = [];
        this.total = 0;
        console.error("Error fetching GRN List:", error);
      } finally {
        this.loading = false;
      }
    },
    searchChange(event) {
      this.search = event;
    },
    goToGrnDetails(item) {
      this.$router.push({ name: "grnDetails", params: { uuid: item.uuid } });
    },
    dropMemberConfirm(uuid) {
      this.dropId = uuid;
      this.confirmOpen = true;
    },

    cancelConfirm() {
      this.confirmOpen = false;
    },

    confirm() {
      this.confirmOpen = false;
      this.dropMember();
    },

    dropMember() {
      if (this.dropId) {
        this.loading = true;
        GrnService.dropMember(this.dropId)
          .then((response) => {
            this.grnList = this.grnList.filter(
              (order) => order.uuid !== this.dropId
            );
            this.snackbar = true;
            this.successMsg = response.message;
          })
          .catch((error) => {
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
            console.error("Error deleting GRN:", error);
          })
          .finally(() => {
            this.loading = false;
            this.dropId = null;
          });
      }
    },
  },
};
</script>
